import { defineMessages } from "react-intl";

const messages = defineMessages({
    type: {
        id: "meta.type",
    },
    folksong: {
        id: "meta.folksong",
    },
    composer: {
        id: "meta.composer",
    },
    country: {
        id: "meta.country",
    },
    tempo: {
        id: "meta.tempo",
    },
    isLyrics: {
        id: "meta.isLyrics",
    },
    language: {
        id: "meta.language",
    },
    isAccompaniment: {
        id: "meta.isAccompaniment",
    },
    isCanon: {
        id: "meta.isCanon",
    },
    title: {
        id: "meta.title",
    },
    genre: {
        id: "meta.genre",
    },
    folksongClass: {
        id: "meta.folksongClass",
    },
    folksongTempo: {
        id: "meta.folksongTempo",
    },
    exerciseType: {
        id: "meta.exerciseType",
    },
    addNewComposer: {
        id: "newComposer.title",
    },
    level: {
        id: "meta.level",
    },
    labels: {
        id: "meta.teaching.labels",
    },
    levelTooltip: {
        id: "meta.teaching.level.tooltip",
    },
    isChildrenSong: {
        id: "meta.opus.isChildrenSong",
    },
    isChurchMusic: {
        id: "meta.opus.isChurchMusic",
    },
});

export default messages;
